// angular
import { Component, effect, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// components
import { ButtonComponent } from '@app/core/components/button/button.component';
// utils
import { DialogRef } from '@app/core/shared/utils/dialog/dialog-ref';
import { DIALOG_DATA } from '@app/core/shared/utils/dialog/dialog-tokens';
// env
import { environment } from '@environments/environment';
import { UserService } from '@app/shared/services/user.service';

@Component({
  selector: 'pwj-submit-request-dialog',
  standalone: true,
  imports: [TranslateModule, ButtonComponent],
  templateUrl: './submit-request-dialog.component.html',
  styleUrl: './submit-request-dialog.component.scss',
})
export class SubmitRequestDialogComponent {
  public panelUrl: string = environment.baseUrl.panelUrl;
  public title!: string;
  public productId!: string;
  public productBusinessId!: string;
  public userBusinessId!: string;

  // dependencies
  private readonly _dialogRef = inject(DialogRef);
  private readonly _userService = inject(UserService);

  public readonly data: {
    title: string;
    productId: string;
    productBusinessId: string;
  } = inject(DIALOG_DATA);

  constructor() {
    // set title
    this.title = this.data.title;
    // set product id
    this.productId = this.data.productId;

    // business id
    this.productBusinessId = this.data.productBusinessId;

    effect(() => {
      if (this._userService.userSignal()?.business?._id) {
        this.userBusinessId = this._userService.userSignal()?.business
          ?._id as string;
      }
    });
  }

  close() {
    this._dialogRef.close();
  }
}
